<template>
  <div style="margin-top: 30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="公司名称"
              prop="name"
              style="margin-right: 15px"
            >
              <el-input
                v-model.trim="form.name"
                placeholder="请输入公司名称"
                @change="
                  value => {
                    form.name = value.replace(/\s/g, '');
                  }
                "
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="公司标记"
              prop="identity"
              style="margin-right: 15px"
            >
              <el-input
                v-model.trim="form.identity"
                placeholder="请输入公司标记"
                @change="
                  value => {
                    form.identity = value.replace(/\s/g, '');
                  }
                "
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="公司地址"
              prop="address"
              style="margin-right: 15px"
            >
              <el-input v-model="form.address" placeholder="请输入公司地址" />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="网址" prop="wwwUrl" style="margin-right: 15px">
              <el-input v-model="form.wwwUrl" placeholder="请输入网址" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="电话" prop="phone" style="margin-right: 15px">
              <el-input v-model="form.phone" placeholder="请输入电话" />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="手机"
              prop="telephone"
              style="margin-right: 15px"
            >
              <el-input v-model="form.telephone" placeholder="请输入手机" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <!--<el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="备案号" prop="beianNumber" style="margin-right:15px">
              <el-input v-model="form.beianNumber" placeholder="请输入备案号" />
            </el-form-item>
          </div>
        </el-col>-->
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="邮箱"
              prop="mailbox"
              style="margin-right: 15px"
            >
              <el-input v-model="form.mailbox" placeholder="请输入邮箱" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="工信号"
              prop="beianProvince"
              style="margin-right: 15px"
            >
              <el-input
                v-model="form.beianProvince"
                type="textarea"
                :rows="3"
                placeholder="请输入工信号"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="平台介绍标题"
              prop="palletTitle"
              style="margin-right: 15px"
            >
              <el-input
                v-model="form.palletTitle"
                placeholder="请输入平台介绍标题"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="平台介绍图片"
              prop="palletUrl"
              style="margin-right: 15px"
            >
              <ImgUpload
                :upload-config="{
                  lebal: '平台介绍图片',
                  prefix: 'palletUrl',
                  form,
                  suffix: '',
                  modal: false
                }"
                :parent-data="{ isDetail: false }"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="平台介绍内容"
              prop="palletDescription"
              style="margin-right: 15px"
            >
              <myEditor v-model="form.palletDescription" :disabled="false" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="公司概况图片"
              prop="overviewsUrl"
              style="margin-right: 15px"
            >
              <ImgUpload
                :upload-config="{
                  lebal: '公司概况图片',
                  prefix: 'overviewsUrl',
                  form,
                  suffix: '',
                  modal: false
                }"
                :parent-data="{ isDetail: false }"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="公司概况"
              prop="overviews"
              style="margin-right: 15px"
            >
              <myEditor v-model="form.overviews" :disabled="false" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="企业文化"
              prop="culture"
              style="margin-right: 15px"
            >
              <myEditor v-model="form.culture" :disabled="false" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="我们承诺"
              prop="promise"
              style="margin-right: 15px"
            >
              <myEditor v-model="form.promise" :disabled="false" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="服务榜单" style="margin-right: 15px">
              <myEditor v-model="form.serviceDescription" :disabled="false" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="黑名单" style="margin-right: 15px">
              <myEditor v-model="form.blacklistDescription" :disabled="false" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="投诉反馈" style="margin-right: 15px">
              <myEditor v-model="form.complaintDescription" :disabled="false" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="公司logo"
              prop="logoImg"
              style="margin-right: 15px"
            >
              <ImgUpload
                :upload-config="{
                  lebal: '公司logo',
                  prefix: 'logoImg',
                  form,
                  suffix: '',
                  modal: false
                }"
                :parent-data="{ isDetail: false }"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="官网二维码1"
              prop="yunyingUrl"
              style="margin-right: 15px"
            >
              <div class="">
                <el-input
                  v-model="form.yunyingName"
                  placeholder="请输入官网二维码1名称"
                  style="width: 75%"
                />
              </div>
              <ImgUpload
                :upload-config="{
                  lebal: '官网二维码1',
                  prefix: 'yunyingUrl',
                  form,
                  suffix: '',
                  modal: false
                }"
                :parent-data="{ isDetail: false }"
              />
            </el-form-item>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="官网二维码2"
              prop="wechatUrl"
              style="margin-right: 15px"
            >
              <div class="">
                <el-input
                  v-model="form.wechatName"
                  placeholder="请输入官网二维码2名称"
                  style="width: 75%"
                />
              </div>
              <ImgUpload
                :upload-config="{
                  lebal: '官网二维码2',
                  prefix: 'wechatUrl',
                  form,
                  suffix: '',
                  modal: false
                }"
                :parent-data="{ isDetail: false }"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <p />
      <p />
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="托运人端app二维码"
              prop="shipperUrl"
              style="margin-right: 15px"
            >
              <ImgUpload
                :upload-config="{
                  lebal: '托运人端app二维码',
                  prefix: 'shipperUrl',
                  form,
                  suffix: '',
                  modal: false
                }"
                :parent-data="{ isDetail: false }"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="司机端app二维码"
              prop="driverUrl"
              style="margin-right: 15px"
            >
              <ImgUpload
                :upload-config="{
                  lebal: '司机端app二维码',
                  prefix: 'driverUrl',
                  form,
                  suffix: '',
                  modal: false
                }"
                :parent-data="{ isDetail: false }"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="isShow">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="托运人端app-ios二维码"
              prop="shipperIosurl"
              style="margin-right: 15px"
            >
              <ImgUpload
                :upload-config="{
                  lebal: '托运人端app-ios二维码',
                  prefix: 'shipperIosurl',
                  form,
                  suffix: '',
                  modal: false
                }"
                :parent-data="{ isDetail: false }"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="司机端app-ios二维码"
              prop="driverIosurl"
              style="margin-right: 15px"
            >
              <ImgUpload
                :upload-config="{
                  lebal: '司机端app-ios二维码',
                  prefix: 'driverIosurl',
                  form,
                  suffix: '',
                  modal: false
                }"
                :parent-data="{ isDetail: false }"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        v-if="getLimit('site_submit_button')"
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import myEditor from "@/components/MyEditor";
import { isURL, isEmail } from "@/utils/validate4Form";
import { validatePhone } from "@/utils/validate.js";
import ImgUpload from "@/components/ImgUpload";
export default {
  name: "SiteEdit",
  components: {
    myEditor,
    ImgUpload
  },
  data() {
    return {
      form: {
        code: "",
        branchCode: "",
        identity: "",
        name: "",
        city: "",
        address: "",
        overviews: "",
        culture: "",
        promise: "",
        complaintDescription: "",
        blacklistDescription: "",
        serviceDescription: "",
        phone: "",
        logoImg: "",
        wwwUrl: "",
        shipperUrl: "",
        shipperIosurl: "",
        driverUrl: "",
        driverIosurl: "",
        yunyingUrl: "",
        telephone: "",
        mailbox: "",
        beianProvince: "",
        beianNumber: "",
        wechatUrl: "",
        bigdataTitleImg: ""
      },
      rules: {
        identity: [
          { required: true, message: "请输入公司标记", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur"
          }
        ],
        name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          {
            min: 1,
            max: 256,
            message: "长度在 1 到 256 个字符",
            trigger: "blur"
          }
        ],
        address: [
          { required: true, message: "请输入公司地址", trigger: "blur" },
          {
            min: 1,
            max: 200,
            message: "长度在 1 到 200 个字符",
            trigger: "blur"
          }
        ],
        wwwUrl: [
          { required: true, message: "请输入网址", trigger: "blur" },
          { validator: isURL, trigger: "blur" },
          {
            min: 1,
            max: 128,
            message: "长度在 1 到 128 个字符",
            trigger: "blur"
          }
        ],
        overviews: [
          {
            min: 1,
            max: 65535,
            message: "长度在 1 到 65535 个字符",
            trigger: "blur"
          }
        ],
        culture: [
          {
            min: 1,
            max: 65535,
            message: "长度在 1 到 65535 个字符",
            trigger: "blur"
          }
        ],
        promise: [
          {
            min: 1,
            max: 65535,
            message: "长度在 1 到 65535 个字符",
            trigger: "blur"
          }
        ],
        phone: [
          { required: true, message: "请输入注册固定电话", trigger: "blur" },
          { min: 1, max: 16, message: "长度在 1 到16个字符", trigger: "blur" }
        ],
        telephone: [
          { required: true, message: "请输入注册手机", trigger: "blur" },
          {
            validator(rule, value, callback) {
              validatePhone(value)
                ? callback()
                : callback(new Error("手机号格式有误"));
            },
            trigger: "blur"
          }
        ],
        mailbox: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: isEmail, trigger: "blur" }
        ],
        beianProvince: [
          { required: true, message: "请输入工信号", trigger: "blur" },
          {
            min: 1,
            max: 500,
            message: "长度在 1 到 500 个字符",
            trigger: "blur"
          }
        ],
        beianNumber: [
          { required: true, message: "请输入备案号", trigger: "blur" },
          {
            min: 1,
            max: 128,
            message: "长度在 1 到128个字符",
            trigger: "blur"
          }
        ],
        logoImg: [
          { required: true, message: "请上传公司logo", trigger: "blur" },
          {
            min: 1,
            max: 128,
            message: "长度在 1 到128个字符",
            trigger: "blur"
          }
        ],
        shipperUrl: [
          {
            required: true,
            message: "请上传托运人端app二维码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 128,
            message: "长度在 1 到128个字符",
            trigger: "blur"
          }
        ],
        shipperIosurl: [
          {
            required: true,
            message: "请上传托运人端app-ios二维码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 128,
            message: "长度在 1 到128个字符",
            trigger: "blur"
          }
        ],
        driverUrl: [
          {
            required: true,
            message: "请上传司机端app二维码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 128,
            message: "长度在 1 到128个字符",
            trigger: "blur"
          }
        ],
        driverIosurl: [
          {
            required: true,
            message: "请上传司机端app-ios二维码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 128,
            message: "长度在 1 到128个字符",
            trigger: "blur"
          }
        ],
        wechatUrl: [
          {
            required: true,
            message: "请上传微信公众号二维码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 128,
            message: "长度在 1 到128个字符",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      return request({ url: `/ntocc-basic-api/site/one`, method: "get" }).then(
        response => {
          if (response.data) {
            this.form = response.data;
          }
        }
      );
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          if (data.code) {
            request({ url: "/ntocc-basic-api/site", method: "put", data }).then(
              response => {
                this.getInfo();
                rLoading.close();
                this.$message({ message: response.msg, type: "success" });
              }
            );
          } else {
            request({
              url: "/ntocc-basic-api/site",
              method: "post",
              data
            }).then(response => {
              this.getInfo();
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
            });
          }
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
